import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../lib/domain';
import ErrorWrapper from '../../lib/error_wrapper';
import { Spin, Collapse, Empty, Badge, Table, Row, Button, Tooltip, message, Divider, Alert } from 'antd';
import Title from 'antd/lib/typography/Title';
import { showErrorInNotification, getRecentRange, schema_to_field, overrideHeaderBack, formatMoney } from '../../lib/util';
import { PopUpForm } from '../../lib/ui/popupform';
import Form from '../../lib/ui/form';
import Paragraph from 'antd/lib/typography/Paragraph';
import { KeyboardArrowRightOutlined } from '@material-ui/icons';

const { Panel } = Collapse;

const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;

const customPanelStyle = {
  background: '#1890ff',
  color: 'white',
  borderRadius: 4,
  marginBottom: 24,
  border: 0,
  overflow: 'hidden',
};

const upload_fields=[
  {
    name: "Upload File",
    index: 'file',
    type: 'file',
    compress: true
}
]
class DatatypeConfigList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      config_list: [],
      loading: true,
      // run_params: {},
      run_schema:[],
      selected_id:null,
      form_visibility: false,
      upload_data:{},
      upload_form_visibility:false
    };
    this.datatype_id = props.match.params.datatype_id

    this.list_configs = RESTExecutor.list().config({
      label: 'repository_list'
    })
      .callbacks((success) => {
        this.setState({
          loading: false,
          config_list: success.result.rows
        })
      }, (error) => {
      })
      .forId(this.datatype_id)
      .connect(props.domains.allData);

      this.upload_file=RESTExecutor.post().config({
        label:'source_upload',
        headers:{Accepts: 'multipart/form-data'}            
        }).callbacks((success)=>{
          message.success(success.result.message || "Upload Complete");
          this.setState({
            selected_id:null,
            upload_form_visibility:false
          })
  
      },(error)=>{
        showErrorInNotification(error);
      }).connect(this.props.domains.allData)

      this.run_fetcher=RESTExecutor.post().config({
        label: 'run_fetcher'
      }).callbacks((success) => {
        message.success(success.result.message || "Running Config Successfully");
        this.setState({
          // run_params: {},
          run_schema:[],
          selected_id:null,
          form_visibility: false,
        })
      }, (error) => {
        showErrorInNotification(error)
      }).connect(this.props.domains.allData)

    this.list_configs.execute()

  };

  runFetcher = (id, data = {}) => {
    console.log("Running", id);
    this.run_fetcher.forId(id).execute(data)


  }

  uploadFile=(upload_data)=>{
    let data=upload_data.file;
    if(!data){
        message.warn("Cannot upload empty data...");
        return;
    }
    let formdata=new FormData();
    formdata.append('file',data);

    this.upload_file.forId(this.state.selected_id).execute(formdata);

    // formdata.append('source_id',this.source_id);

    // this.upload_file.forId(this.state.selected_id)
    // .execute(formdata);
  }

  render() {
    let list_resp = this.list_configs.response();
    const { loading, config_list } = this.state;
    if (loading) {
      return <center><Spin /></center>
    }

    let upload_file_resp=this.upload_file.response();
    let run_fetcher_resp=this.run_fetcher.response();

    return (
      <ErrorWrapper
        error={list_resp}
        onReload={() => {
          this.setState({
            loading: true
          });
          this.list_configs.execute();
        }}
      >
        <div>
          {/* <CustomHeader title={"Config List"} /> */}
          <br></br>
          {config_list.length === 0 ?
            <center><Empty /></center> : null
          }

          <PopUpForm
            width="60%"
            key={`${this.state.selected_id}upload`}
            title={"Upload File"}
            show_title_only
            forCreate={true}
            initialData={{}}
            fields={upload_fields}
            open={this.state.upload_form_visibility}
            networkState={upload_file_resp}
            onClose={() => {
              console.log("closing upload form")
              this.setState({ 
              upload_form_visibility: false,
              selected_id:null
            })
            }
            }
            onSubmit={(data) => {
              console.log("DATA", data);
              this.uploadFile(data);
            }}
          />

          <PopUpForm
            key={`${this.state.selected_id}run`}
            title={"Required Params"}
            show_title_only
            forCreate={true}
            initialData={{}}
            fields={this.state.run_schema}
            open={this.state.form_visibility}
            networkState={run_fetcher_resp}
            onClose={() => {
              console.log("closing form")
              this.setState({ form_visibility: false,
                selected_id:null,
                run_schema:[],
                // run_params:{}
              })}
            }
            onSubmit={(data) => {
              console.log("DATA", data);
              this.runFetcher(this.state.selected_id, data);
            }}
          />

          <Collapse
            bordered={false}
            className='no-bg-collapse'
            destroyInactivePanel
            defaultActiveKey={['0']}
            expandIcon={({ isActive }) => <KeyboardArrowRightOutlined type="caret-right" 
            
            style={{
              transform:`rotateZ(${isActive?90:0}deg)`
            }}
            rotate={isActive ? 90 : 0} />}
          >
            {config_list.map((item,config_index) => {
              // let next_run_moment = getRecentRange(item.schedule).next;
              let need_more_params = false;
              var schema = [];
              if (Array.isArray(item.on_run_config) && item.on_run_config.length > 0) {
                need_more_params = true;
                // schema = schema_to_field(item.on_run_config);
                // console.log("schema is",schema)
              }
              return <Panel header={<Row type='flex' justify='space-between'>

                <Title style={{ color: 'inherit', margin: 0 }} level={4}> {item.name} </Title>
                {/* {next_run_moment && <Tooltip title={next_run_moment.format("YYYY-MM-DD HH:mmA")}>
                  <Badge status='success' style={{ color: 'inherit', display: 'flex', alignItems: 'center' }} text={`Next Run: ${next_run_moment.fromNow()}`} />
                </Tooltip>} */}
                {/* {item.repository_type==='scheduled'&& */}
                <span>
                <Tooltip title="Run this Fetcher">
                  <Button type='dashed'

                    // icon={'play-circle'}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (Array.isArray(item.on_run_config) && item.on_run_config.length > 0) {
                        this.setState({
                          // run_params: {},
                          selected_id: item.id,
                          run_schema: schema_to_field(item.on_run_config),
                          form_visibility:true
                        })

                      } else {
                        this.runFetcher(item.id)
                      }

                    }}
                  >Run</Button>
                </Tooltip>
                {/* } */}
                <Tooltip title="Upload to this Fetcher">
                  <Button type='dashed' style={{marginLeft:12}}

                    // icon={'play-circle'}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setState({
                        upload_form_visibility:true,
                        selected_id:item.id
                      })

                      // if (Array.isArray(item.on_run_config) && item.on_run_config.length > 0) {
                      //   this.setState({
                      //     run_params: {},
                      //     selected_id: item.id,
                      //     run_schema: schema_to_field(item.on_run_config),
                      //     form_visibility:true
                      //   })

                      // } else {
                      //   this.runFetcher(item.id)
                      // }
                    }}
                  >Upload</Button>
                </Tooltip>
                </span>
              </Row>}
                key={config_index}

                style={customPanelStyle}
                className='config-collapse-panel'>

                <LogsForFetcher
                  fetcher_id={item.id}
                />

              </Panel>
            })
            }
          </Collapse>
        </div>
      </ErrorWrapper>
    );
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.match.params.datatype_id !== prevProps.match.params.datatype_id) {
      this.datatype_id = this.props.match.params.datatype_id;
      this.setState({
        loading: true
      })
      this.list_configs.forId(this.datatype_id).execute()
      // fetch the new product based and set it to the state of the component
    };
  };

  componentDidMount(){
   

  }

  componentWillUnmount(){
  }


}

export default DatatypeConfigList=withDomains(DatatypeConfigList, "allData");


const logs_cols = ({ }) => [
  {
    title: "Executed At",
    dataIndex: 'executed_at',
    key: 'executed_at'
  },
  {
    title: "Completed At",
    dataIndex: 'completed_at',
    key: 'completed_at'
  },
  {
    title: "Status",
    dataIndex: 'status',
    key: 'status',
    render: (status) => {

      return <Badge status={status=='Completed' ?'success':(status=='Executing'?'processing': 'error')} text={status||""} />
    }
  }
]
class LogsForFetcherOnly extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      list_data: [],
      list_meta: {},
      loading: true,
      expandedKeys: []
    }
    // console.log(this.props);
    this.list_logs = RESTExecutor.list().config({
      label: 'fetcher_logs'
    })
      .callbacks((success) => {
        this.setState({
          list_data: success.result.rows,
          list_meta: success.meta,
          loading: false
        })
      })
      .forId(this.props.fetcher_id).connect(props.domains.allData);

    this.list_logs.execute()


  }

  render() {
    const { loading, list_data, list_meta, expandedKeys } = this.state;
    return (<div>
      <Table
        columns={logs_cols({
        })}
        dataSource={list_data}
        className='ant-table-small-noborder  '
        size='small'
        scroll={{x:true}}
        expandedRowKeys={expandedKeys}
        loading={loading}
        expandedRowRender={(record, index, indent, expanded) => {
          return expanded ? <ResponsesForLogs
            data={record}
            log_id={record.id}
          /> : null
        }}
        onExpandedRowsChange={(exp_rows) => {
          console.log(exp_rows);
          this.setState({
            expandedKeys: exp_rows
          })
        }}
        pagination={{
          simple: true,
          onChange: (current, size) => {
            this.setState({
              loading: true,
              expandedKeys: []
            })
            this.list_logs.config({
              params: {
                per_page: size,
                page: current
              }
            }).execute();
          },
          defaultCurrent: 1,
          current: list_meta.pagination && parseInt(list_meta.pagination.split('/')[0]),
          // defaultPageSize: 20,
          pageSize: (list_meta && list_meta.requested_count),

          total: (list_meta && list_meta.total_count),
          showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
        }}

        title={() => <Row type='flex' justify='space-between' style={{
          alignItems: 'center'
        }}><Title
          type='secondary'
          level={4}

          style={{
            margin: 0
          }}>Execution Logs</Title>

        </Row>}
        rowKey={(record) => record.id}
      />
    </div>)
  }
}

export const LogsForFetcher = withDomains(LogsForFetcherOnly, "allData");



const responses_cols = ({onDownload,onRerun }) => [
  {
    title: "File Name",
    dataIndex: 'uploaded_file_name',
    key: 'uploaded_file_name'
  },
  {
    title: "File Size(KB)",
    dataIndex: 'file_size',
    key: 'file_size',
    render: (size) => {
      if (size != null) {
        return (size / 1024).toFixed(2)
      }
    }
  },
  {
    title: "Rows extracted",
    dataIndex: 'rows_count',
    key: 'rows_count'
  },
  {
    title: "Action",
    dataIndex: 'id',
    key: 'id',
    render: (id) => {
      return <span>
         <Button onClick={()=>{
          typeof onDownload==='function'&&onDownload(id)
        }} type='link'>Download</Button>
        <Divider type='vertical'/>
        <Button onClick={()=>{
          typeof onRerun==='function'&&onRerun(id)
        }} type='link'>Re-run</Button>
       </span>
    }
  }
]
class ResponsesForLogsOnly extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      list_data: [],
      list_meta: {},
      loading: true,
      list_selectors:[],
      selected_response_id:null,
      form_visibility:false,
    }
    console.log(this.props);
    this.list_responses = RESTExecutor.list().config({
      label: 'responses'
    })
      .callbacks((success) => {
        this.setState({
          list_data: success.result.rows,
          list_meta: success.meta,
          loading: false,
        })
      })
      .forId(this.props.log_id).connect(props.domains.allData);

    this.list_responses.execute()

    this.download_response=RESTExecutor.detail().config({
      label:'download_responses'
    }).callbacks((success)=>{
      window.open(success.result.url, '_blank');
    },(error)=>{
      showErrorInNotification(error)
    }).connect(props.domains.allData);

    this.list_selectors=RESTExecutor.list().config({
      label:'response_selectors'
    }).callbacks((success)=>{
        let options=[];
        success.result.rows.map((item)=>{
          options.push({
            text:item.name,value:item.id
          });
        });
        this.setState({list_selectors:options});
    }).connect(props.domains.allData);

    
    this.re_run=RESTExecutor.post().config({
      label:'rerun_responses'
    }).callbacks((success)=>{
      message.success(success.result.message || "Running selector.");
      this.setState({
        selected_response_id:null,
        form_visibility:false,
      })
    },(error)=>{
      showErrorInNotification(error)
    }).connect(props.domains.allData);




  }

  reRun=(data)=>{

    this.re_run.forId(this.state.selected_response_id).execute(data);
      // Rerun for given responses
  }
  render() {
    const { loading, list_data, list_meta,list_selectors } = this.state;

    let re_run_resp=this.re_run.response();

    const required_fields=[
      {filterable:true,index:'selector_id',name:"Selector",help_text:"Which selector to run for given file.",type:'select',options:list_selectors}
    ]
    let response_data=this.props.data||{};

    return (<div>
      {response_data.status=='Failed'&&
      <Alert
      message={response_data.status}
      description={ <Paragraph  className='log-text' ellipsis={{ rows: 3, expandable: true }}>
        {response_data.message}
      </Paragraph>}
      type='error'
      closable
    />}

      <PopUpForm
            width="60%"
            key={`${this.state.selected_response_id}rerun`}
            title={"Selector to Rerun"}
            show_title_only
            forCreate={true}
            initialData={{}}
            fields={required_fields}
            open={this.state.form_visibility}
            networkState={re_run_resp}
            onClose={() => {
              console.log("closing upload form")
              this.setState({ 
              form_visibility: false,
              selected_response_id:null,
              form_data:{}
            })
            }
            }
            onSubmit={(data) => {
              console.log("DATA", data);
              this.reRun(data);
            }}
          />
      <Table
        columns={responses_cols({
          onDownload:(id)=>{
            this.download_response.forId(id).execute();
          },
          onRerun:(id)=>{
            this.list_selectors.forId(id).execute();
            this.setState({
              selected_response_id:id,form_visibility:true
            })
          }
        })}
        dataSource={list_data}
        className='ant-table-small-noborder  '
        size='small'
        scroll={{x:true}}
        loading={loading}
        pagination={{
          simple: true,
          onChange: (current, size) => {
            this.setState({
              loading: true,
            })
            this.list_responses.config({
              params: {
                per_page: size,
                page: current
              }
            }).execute();
          },
          defaultCurrent: 1,
          current: list_meta.pagination && parseInt(list_meta.pagination.split('/')[0]),
          // defaultPageSize: 20,
          pageSize: (list_meta && list_meta.requested_count),

          total: (list_meta && list_meta.total_count),
          showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
        }}

        title={() => <Row type='flex' justify='space-between' style={{
          alignItems: 'center'
        }}><Title
          type='secondary'
          level={4}

          style={{
            margin: 0
          }}>Responses</Title>

        </Row>}
        rowKey={(record) => record.id}
      />
    </div>)
  }
}

export const ResponsesForLogs = withDomains(ResponsesForLogsOnly, "allData");